import * as React from 'react';
import Box from '@mui/material/Box';
import MuiModal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ModalProps } from 'types/modal';

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', lg: '25%' },
    borderRadius: 2,
    bgcolor: 'background.paper',
    boxShadow: 24,
    // p: 2,
};

const Modal = ({ isOpen, modalTitle, children, onClose }: ModalProps) => {
    return (
        <MuiModal
            keepMounted
            open={isOpen}
            onClose={onClose}
            aria-labelledby="confirm-modal-title"
            aria-describedby="confirm-modal-description"
        >
            <Box sx={style} style={{ width: '100%', maxWidth: '600px' }}>
                <Stack width="100%" p={2} sx={{ position: 'relative' }}>
                    <IconButton onClick={onClose} sx={{ position: 'absolute', top: 5, right: 5 }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography
                        sx={{ textAlign: 'center', fontWeight: 600, fontSize: { xs: 16, sm: 22 } }}
                        id="confirm-modal-title"
                        variant="h6"
                        component="h1"
                        textTransform="capitalize"
                    >
                        {modalTitle}
                    </Typography>
                    {children && (
                        <div id="confirm-modal-description" style={{ margin: 6, textAlign: 'center' }}>
                            {children}
                        </div>
                    )}
                </Stack>
            </Box>
        </MuiModal>
    );
};

export default Modal;
